import React from 'react';
import { Modal, Form, Input } from 'antd';
  
  const SubUnitDialogForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends React.Component {
      render() {
        const { visible, onCancel, onCreate, form, data} = this.props;
        const { getFieldDecorator } = form;

        return (
          <Modal
            visible={visible}
            title="Add Sub Unit"
            okText="Save"
            onCancel={onCancel}
            onOk={onCreate}>

            <Form layout="vertical">
              <Form.Item label="Sub Unit">
                {getFieldDecorator('subUnit', {
                 initialValue: data.subUnit,
                  rules: [{ required: true, message: 'Please input the Sub Unit!' }],
                })( <Input /> )}
              </Form.Item>
            </Form>

          </Modal>
        );
      }
    }
  );

  export default SubUnitDialogForm;
